import {
  InputTextArea,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import React, { useContext } from "react";
import { FormContext } from "../context/FormContext";

const RmExternal = ({ setShowModal }) => {
  const { formData, setFormData } = useContext(FormContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowModal(false);
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={"RM Ext"} show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name='nama'
              label='Nama'
              id='nama'
              value={formData.nama}
              onChange={handleChange("nama")}
              placeholder='Nama'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextArea
              label={"Keterangan"}
              placeholder={"Keterangan"}
              name='keterangan'
              value={formData.keterangan}
              onChange={handleChange("keterangan")}
              id='keterangan'
              rows={"3"}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={"green"}
            name={"Simpan"}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};

export default RmExternal;
